/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events  */
import React from 'react';
import { Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import onClickOutside from 'react-onclickoutside';

import { AppState } from 'services/types';
import { openSidebar, closeSidebar } from 'services/ui/actions';
// @ts-ignore
import { selectCurrentOrganizationId } from 'services/currentOrganizationId/selectors';
import { selectOpenSidebar } from 'services/ui/selectors';
// @ts-ignore
import OrganizationHasWorkTypesGate from 'components/OrganizationHasWorkTypesGate';
import RoleGate from 'components/RoleGate';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER,
    PAYROLL,
    FIELD_STAFF,
    SUPERVISOR
} from 'components/RoleGate/constants';
// @ts-ignore
import SeasonDropdown from 'components/SeasonDropdown';
// @ts-ignore
import EntityTypeEntityDropdowns from 'components/EntityTypeEntityDropdowns';
// @ts-ignore
import EntityTypesExistGate from 'components/EntityTypesExistGate';
import HarvestSchemaExistsGate from 'components/HarvestSchemaExistsGate';
import SchemasWithoutEventTypeIdExistGate from 'components/SchemasWithoutEventTypeIdExistGate';
import SpraySchemaExistsGate from 'components/SpraySchemaExistsGate';
import MyTimesheetsExistsGate from 'components/MyTimesheetsExistsGate';

import OrganizationName from 'components/OrganizationName';
import FertilizerSchemaExistsGate from 'components/FertilizerSchemaExistsGate';
import SettingsExistsGate from './components/SettingsExistsGate';
// @ts-ignore
import EntitiesSidebarNavigationItem from './components/EntitiesSidebarNavigationItem';
// @ts-ignore
import FeedbackSidebarNavigationItemButton from './components/FeedbackSidebarNavigationItemButton';
// @ts-ignore
import LogoutSidebarNavigationItemButton from './components/LogoutSidebarNavigationItemButton';
// @ts-ignore
import Pathname from './components/Pathname';
// @ts-ignore
import PinSidebarButton from './components/PinSidebarButton';
// @ts-ignore
import SidebarNavigationItemLink from './components/SidebarNavigationItemLink';
// @ts-ignore
import SidebarNavigationItem from './components/SidebarNavigationItem';
// @ts-ignore
import SidebarNavigationLogo from './components/SidebarNavigationLogo';
// @ts-ignore
import SidebarSubnavigationCollapse from './components/SidebarSubnavigationCollapse';
// @ts-ignore
import SidebarSubnavigationLink from './components/SidebarSubnavigationLink';
// @ts-ignore
import SidebarSubnavigationOther from './components/SidebarSubnavigationOther';
import './styles.scss';
import SupportSidebarNavigationItem from './components/SupportSidebarNavigationItem';

interface ConnectedProps {
    open?: ReturnType<typeof selectOpenSidebar>;
    currentOrganizationId?: ReturnType<typeof selectCurrentOrganizationId>;
}

interface State {
    expanded: string | null | undefined;
    hovered: boolean | null | undefined;
    timeoutId: ReturnType<typeof setTimeout> | undefined;
}

interface DispatchProps {
    closeSidebar: typeof closeSidebar;
    openSidebar: typeof openSidebar;
}

type Props = ConnectedProps & DispatchProps;

enum TopLevelMenu {
    HARVEST = 'harvest',
    JOBS = 'jobs',
    FERTILIZER = 'fertilizer',
    SPRAY = 'spray',
    AREAS = 'areas',
    WORKFORCE = 'workforce',
    TIME = 'time',
    SETTINGS = 'settings'
}

export class SidebarNavigation extends React.Component<Props, State> {
    state = {
        expanded: null,
        timeoutId: undefined,
        hovered: false
    };

    handleChange = (): void => {
        this.props.closeSidebar();
    };

    handleMouseEnter = (): void => {
        // Delay opening animation
        const timeoutId = setTimeout(() => {
            this.props.openSidebar();
        }, 300);

        this.setState({ timeoutId });
    };

    handleMouseLeave = (): void => {
        clearTimeout(this.state.timeoutId);
        this.props.closeSidebar();

        this.setState({
            expanded: null
        });
    };

    handleOrgMouseEnter = (): void => {
        this.setState({
            hovered: true
        });
    };

    handleOrgMouseLeave = (): void => {
        this.setState({
            hovered: false
        });
    };

    handleClickOutside = (): void => {
        clearTimeout(this.state.timeoutId);
        this.props.closeSidebar();

        this.setState({
            expanded: null
        });
    };

    handleClick = (): void => {
        if (!this.props.open) {
            this.props.openSidebar();
        }
    };

    handleExpand = (item?: string) => (): void => {
        this.props.openSidebar();

        this.setState((prevState: State) => {
            return {
                expanded: prevState.expanded === item ? null : item
            };
        });
    };

    render(): React.ReactElement {
        const { open, currentOrganizationId } = this.props;
        const { expanded, hovered } = this.state;

        return (
            <div>
                <Pathname onChange={this.handleChange} />
                <div
                    className={`sidebar-navigation ${open ? 'open' : ''}`}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                    onClick={this.handleClick}
                >
                    <div className="sidebar-navigation-inner">
                        <PinSidebarButton />
                        <SidebarNavigationLogo />
                        {currentOrganizationId && (
                            <div className="sidebar-navigation-top">
                                <HarvestSchemaExistsGate>
                                    <React.Fragment>
                                        <SidebarNavigationItemLink
                                            pathname="/organization/harvest"
                                            title="Harvest"
                                            iconName="FiCalendar"
                                            expanded={
                                                expanded ===
                                                TopLevelMenu.HARVEST
                                            }
                                            onClick={this.handleExpand(
                                                TopLevelMenu.HARVEST
                                            )}
                                        />
                                        <SidebarSubnavigationCollapse
                                            expanded={
                                                expanded ===
                                                TopLevelMenu.HARVEST
                                            }
                                        >
                                            <SidebarSubnavigationLink
                                                pathname="/organization/harvest/pick-schedule"
                                                title="Pick Schedule"
                                                onClick={this.handleMouseLeave}
                                            />
                                            <RoleGate
                                                requiredRoles={[
                                                    ADMIN,
                                                    MANAGER,
                                                    ASSISTANT_MANAGER
                                                ]}
                                            >
                                                <React.Fragment>
                                                    <SidebarSubnavigationLink
                                                        pathname="/organization/harvest/bin-forecasts"
                                                        title="Bin Forecasts"
                                                        onClick={
                                                            this
                                                                .handleMouseLeave
                                                        }
                                                    />
                                                    <SidebarSubnavigationLink
                                                        pathname="/organization/harvest/quality-report"
                                                        title="Quality Report"
                                                        onClick={
                                                            this
                                                                .handleMouseLeave
                                                        }
                                                    />
                                                    <SidebarSubnavigationLink
                                                        pathname="/organization/harvest/bin-check-report"
                                                        title="Bin Check Report"
                                                        onClick={
                                                            this
                                                                .handleMouseLeave
                                                        }
                                                    />
                                                </React.Fragment>
                                            </RoleGate>
                                        </SidebarSubnavigationCollapse>
                                    </React.Fragment>
                                </HarvestSchemaExistsGate>
                                <SchemasWithoutEventTypeIdExistGate>
                                    <SidebarNavigationItemLink
                                        pathname="/organization/jobs"
                                        title="Jobs"
                                        iconName="FiFileText"
                                        expanded={
                                            expanded === TopLevelMenu.JOBS
                                        }
                                        onClick={this.handleExpand(
                                            TopLevelMenu.JOBS
                                        )}
                                    />
                                    <SidebarSubnavigationCollapse
                                        expanded={
                                            expanded === TopLevelMenu.JOBS
                                        }
                                    >
                                        <SidebarSubnavigationLink
                                            pathname="/organization/jobs/planner"
                                            title="Planner"
                                            onClick={this.handleMouseLeave}
                                        />
                                        <RoleGate
                                            requiredRoles={[
                                                ADMIN,
                                                MANAGER,
                                                ASSISTANT_MANAGER
                                            ]}
                                        >
                                            <SidebarSubnavigationLink
                                                pathname="/organization/jobs/settings"
                                                title="Settings"
                                                onClick={this.handleMouseLeave}
                                            />
                                        </RoleGate>
                                    </SidebarSubnavigationCollapse>
                                </SchemasWithoutEventTypeIdExistGate>
                                <FertilizerSchemaExistsGate>
                                    <RoleGate
                                        requiredRoles={[
                                            ADMIN,
                                            MANAGER,
                                            ASSISTANT_MANAGER
                                        ]}
                                    >
                                        <React.Fragment>
                                            <SidebarNavigationItemLink
                                                pathname="/organization/Fertilizer"
                                                title="Fertilizer"
                                                iconName="FiGlobe"
                                                expanded={
                                                    expanded ===
                                                    TopLevelMenu.FERTILIZER
                                                }
                                                onClick={this.handleExpand(
                                                    TopLevelMenu.FERTILIZER
                                                )}
                                            />
                                            <SidebarSubnavigationCollapse
                                                expanded={
                                                    expanded ===
                                                    TopLevelMenu.FERTILIZER
                                                }
                                            >
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/fertilizer/diary"
                                                    title="Diary"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/fertilizer/products"
                                                    title="Products"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                            </SidebarSubnavigationCollapse>
                                        </React.Fragment>
                                    </RoleGate>
                                </FertilizerSchemaExistsGate>
                                <SpraySchemaExistsGate>
                                    <RoleGate
                                        requiredRoles={[
                                            ADMIN,
                                            MANAGER,
                                            ASSISTANT_MANAGER
                                        ]}
                                    >
                                        <React.Fragment>
                                            <SidebarNavigationItemLink
                                                pathname="/organization/spray"
                                                title="Spray"
                                                iconName="FiDroplet"
                                                expanded={
                                                    expanded ===
                                                    TopLevelMenu.SPRAY
                                                }
                                                onClick={this.handleExpand(
                                                    TopLevelMenu.SPRAY
                                                )}
                                            />
                                            <SidebarSubnavigationCollapse
                                                expanded={
                                                    expanded ===
                                                    TopLevelMenu.SPRAY
                                                }
                                            >
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/spray/crop-diary"
                                                    title="Crop Diary"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/spray/weed-diary"
                                                    title="Weed Diary"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/spray/equipment-sets"
                                                    title="Equipment Sets"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/spray/equipment"
                                                    title="Equipment"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/spray/products"
                                                    title="Products"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/spray/active-ingredients"
                                                    title="Active Ingredients"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/spray/submissions"
                                                    title="Submissions"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                            </SidebarSubnavigationCollapse>
                                        </React.Fragment>
                                    </RoleGate>
                                </SpraySchemaExistsGate>
                                <EntityTypesExistGate>
                                    <SidebarNavigationItemLink
                                        pathname="/organization/areas"
                                        title="Areas"
                                        iconName="FiMapPin"
                                        expanded={
                                            expanded === TopLevelMenu.AREAS
                                        }
                                        onClick={this.handleExpand(
                                            TopLevelMenu.AREAS
                                        )}
                                    />
                                    <SidebarSubnavigationCollapse
                                        expanded={
                                            expanded === TopLevelMenu.AREAS
                                        }
                                    >
                                        <EntitiesSidebarNavigationItem
                                            onClick={this.handleMouseLeave}
                                        />
                                    </SidebarSubnavigationCollapse>
                                </EntityTypesExistGate>
                                <RoleGate
                                    requiredRoles={[
                                        ADMIN,
                                        MANAGER,
                                        ASSISTANT_MANAGER,
                                        PAYROLL
                                    ]}
                                >
                                    <React.Fragment>
                                        <SidebarNavigationItemLink
                                            pathname="/organization/workforce"
                                            title="Workforce"
                                            iconName="FiUsers"
                                            expanded={expanded === 'item3'}
                                            onClick={this.handleExpand('item3')}
                                        />
                                        <SidebarSubnavigationCollapse
                                            expanded={expanded === 'item3'}
                                        >
                                            <SidebarSubnavigationLink
                                                pathname="/organization/workforce/people"
                                                title="People"
                                                onClick={this.handleMouseLeave}
                                            />
                                            <SidebarSubnavigationLink
                                                pathname="/organization/workforce/groups"
                                                title="Groups"
                                                onClick={this.handleMouseLeave}
                                            />
                                        </SidebarSubnavigationCollapse>
                                    </React.Fragment>
                                </RoleGate>
                                <OrganizationHasWorkTypesGate>
                                    <SidebarNavigationItemLink
                                        pathname="/organization/time"
                                        title="Time"
                                        iconName="FiClock"
                                        expanded={
                                            expanded === TopLevelMenu.TIME
                                        }
                                        onClick={this.handleExpand(
                                            TopLevelMenu.TIME
                                        )}
                                    />
                                    <SidebarSubnavigationCollapse
                                        expanded={
                                            expanded === TopLevelMenu.TIME
                                        }
                                    >
                                        <MyTimesheetsExistsGate>
                                            <RoleGate
                                                requiredRoles={[
                                                    ADMIN,
                                                    MANAGER,
                                                    ASSISTANT_MANAGER,
                                                    FIELD_STAFF,
                                                    SUPERVISOR
                                                ]}
                                            >
                                                <SidebarSubnavigationLink
                                                    pathname="/organization/time/my-timesheets"
                                                    title="My Timesheets"
                                                    onClick={
                                                        this.handleMouseLeave
                                                    }
                                                />
                                            </RoleGate>
                                        </MyTimesheetsExistsGate>
                                        <RoleGate
                                            requiredRoles={[
                                                ADMIN,
                                                MANAGER,
                                                ASSISTANT_MANAGER,
                                                PAYROLL
                                            ]}
                                        >
                                            <SidebarSubnavigationLink
                                                pathname="/organization/time/timesheets"
                                                title="Timesheets"
                                                onClick={this.handleMouseLeave}
                                            />
                                        </RoleGate>
                                        <RoleGate
                                            requiredRoles={[
                                                ADMIN,
                                                MANAGER,
                                                ASSISTANT_MANAGER,
                                                PAYROLL
                                            ]}
                                        >
                                            <SidebarSubnavigationLink
                                                pathname="/organization/time/entries"
                                                title="Entries"
                                                onClick={this.handleMouseLeave}
                                            />
                                        </RoleGate>
                                        <SidebarSubnavigationLink
                                            pathname="/organization/time/tasks"
                                            title="Tasks"
                                            onClick={this.handleMouseLeave}
                                        />
                                        <RoleGate
                                            requiredRoles={[ADMIN, PAYROLL]}
                                        >
                                            <SidebarSubnavigationLink
                                                pathname="/organization/time/holidays"
                                                title="Holidays"
                                                onClick={this.handleMouseLeave}
                                            />
                                        </RoleGate>
                                        <RoleGate
                                            requiredRoles={[ADMIN, PAYROLL]}
                                        >
                                            <SidebarSubnavigationLink
                                                pathname="/organization/time/submissions"
                                                title="Submissions"
                                                onClick={this.handleMouseLeave}
                                            />
                                        </RoleGate>
                                    </SidebarSubnavigationCollapse>
                                </OrganizationHasWorkTypesGate>
                                <SettingsExistsGate>
                                    <RoleGate requiredRoles={[ADMIN]}>
                                        <React.Fragment>
                                            <SidebarNavigationItemLink
                                                pathname="/organization/settings"
                                                title="Settings"
                                                iconName="FiSettings"
                                                expanded={
                                                    expanded ===
                                                    TopLevelMenu.SETTINGS
                                                }
                                                onClick={this.handleExpand(
                                                    TopLevelMenu.SETTINGS
                                                )}
                                            />
                                            <SidebarSubnavigationCollapse
                                                expanded={
                                                    expanded ===
                                                    TopLevelMenu.SETTINGS
                                                }
                                            >
                                                <SpraySchemaExistsGate>
                                                    <SidebarSubnavigationLink
                                                        pathname="/organization/settings/spray"
                                                        title="Spray"
                                                        onClick={
                                                            this
                                                                .handleMouseLeave
                                                        }
                                                    />
                                                </SpraySchemaExistsGate>
                                                <HarvestSchemaExistsGate>
                                                    <React.Fragment>
                                                        <SidebarSubnavigationLink
                                                            pathname="/organization/settings/varieties"
                                                            title="Varieties"
                                                            onClick={
                                                                this
                                                                    .handleMouseLeave
                                                            }
                                                        />
                                                        <SidebarSubnavigationLink
                                                            pathname="/organization/settings/commodities"
                                                            title="Commodities"
                                                            onClick={
                                                                this
                                                                    .handleMouseLeave
                                                            }
                                                        />
                                                    </React.Fragment>
                                                </HarvestSchemaExistsGate>
                                            </SidebarSubnavigationCollapse>
                                        </React.Fragment>
                                    </RoleGate>
                                </SettingsExistsGate>
                                <hr className="sidebar-navigation-hr" />
                                <SidebarNavigationItem
                                    title="View data from:"
                                    iconName="FiEye"
                                />
                                <SidebarSubnavigationOther>
                                    <Form>
                                        <Form.Field>
                                            <SeasonDropdown selection fluid />
                                        </Form.Field>
                                        <Form.Field>
                                            <EntityTypeEntityDropdowns
                                                limit={1}
                                                offset={0}
                                                selection
                                                fluid
                                            />
                                        </Form.Field>
                                    </Form>
                                </SidebarSubnavigationOther>
                            </div>
                        )}
                        <div className="sidebar-navigation-bottom">
                            <SupportSidebarNavigationItem />
                            <FeedbackSidebarNavigationItemButton />
                            <SidebarNavigationItemLink
                                pathname="/organizations"
                                title={
                                    hovered ? (
                                        'Organizations'
                                    ) : (
                                        <OrganizationName
                                            organizationId={
                                                currentOrganizationId
                                            }
                                        />
                                    )
                                }
                                iconName="FiBox"
                                onMouseEnter={this.handleOrgMouseEnter}
                                onMouseLeave={this.handleOrgMouseLeave}
                            />
                            <LogoutSidebarNavigationItemButton />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    currentOrganizationId: selectCurrentOrganizationId,
    open: selectOpenSidebar
});

export default connect(mapStateToProps, { openSidebar, closeSidebar })(
    onClickOutside(SidebarNavigation)
);
